import React, { useState } from 'react'
import PropTypes from 'prop-types'
import AsyncSelect from 'react-select/async'
import School from '../../../models/School'
import District from '../../../models/District'
import Select from "react-select";
import styles from './FallJobRequest.module.sass'

const SchoolAsyncSelect = ({ name, placeholder, jotformUrl, id }) => {
  const [school, setSchool] = useState()
  const [district, setDistrict] = useState()
  const [schoolEmployee, setSchoolEmployee] = React.useState("");
  const [email, setEmail] = React.useState("");
  const [firstname, setFirstname] = React.useState("");
  const [lastname, setLastname] = React.useState("");

  const isMobile = window.screen.width < 600

  const changeHandler = (opt) => {
    setSchool(opt)
  }

  const changeDistrictHandler = (opt) => {
    setDistrict(opt)
    setSchool()
  }

  const changeSchoolEmployee = (opt) => {
    setSchoolEmployee(opt)
    console.log(id)
  }

  const changeEmail = (opt) => {
    setEmail(opt)
    formatUrl()
    console.log(opt)
  }

  const options = [
    { value: "None", label: "None" },
    { value: "Principal", label: "Principal" },
    { value: "Vice-Principal", label: "Vice-Principal" },
    { value: "Office Manager", label: "Office Manager" },
    { value: "Secretary", label: "Secretary" },
    { value: "Teacher", label: "Teacher" },
    { value: "Educational Support", label: "Educational Support" }
  ];

  const formatUrl = () => {
    if (!school) return '';
    const url = new URL(jotformUrl);
    url.searchParams.append('school_employee', schoolEmployee.value);
    url.searchParams.append('schoolId', school.value);
    url.searchParams.append('email', email);
    //url.searchParams.append('req_id', id);
    

    return url
  }

  const loadSchoolOptionsQuery = () => (value, callback) => {
    School
      .where({
        district_id: district.data.id,
        name: { match: value },
      })
      .order({ name: 'asc' })
      .per(50)
      .all()
      .then((res) => {
        const options = res.data.map((e) => ({ label: e.name, value: e.id, data: e }))
        callback(options)
      })
  }

  const loadDistrictOptionsQuery = () => (value, callback) => {
    District
      .where({
        name: { match: value }
      })
      .order({ name: 'asc' })
      .per(50)
      .all()
      .then((res) => {
        const options = res.data.map((e) => ({ label: e.name, value: e.id, data: e }))
        callback(options)
      })
  }

  return (
    <>
      
      
      <label htmlFor="district" className={styles.bluelabel2}>Select District</label>
      <AsyncSelect
        cacheOptions
        className={styles.dropdown}
        defaultOptions
        placeholder="Type   the   3 letters your School District starts with"
        defaultValue={district}
        name="district"
        loadOptions={loadDistrictOptionsQuery()}
        onChange={changeDistrictHandler}
      />

      <br/>
      {district && (
        <label htmlFor="school" className={styles.bluelabel}>School</label>
        )}


      {district && (

        <AsyncSelect
          cacheOptions
          className={styles.dropdown}
          defaultOptions
          placeholder={placeholder}
          defaultValue={school}
          name="school"
          key={district.value}
          loadOptions={loadSchoolOptionsQuery()}
          onChange={changeHandler}
        />
        
      )}
      
      <br/>
      {school && (   
        <label htmlFor="school" className={styles.bluelabel}>Postion</label>
        
        )

     }
       {school && (   
        <Select
          options={options}
          className={styles.dropdown}
          onChange={(e) => changeSchoolEmployee(e)}
          value={schoolEmployee}
          name="postion"
          label="Single select"
          placeholder={"Select your position"}
          menuPlacement="top"
          required
        />
        
        )

     }
        
     
      <br/>

      
    </>
  )
}

SchoolAsyncSelect.propTypes = {
  name: PropTypes.string,
  selectedValue: PropTypes.object,
  valueField: PropTypes.string,
  extraFields: PropTypes.array,
  placeholder: PropTypes.string,
}

SchoolAsyncSelect.defaultProps = {
  name: null,
  selectedValue: null,
  valueField: 'name',
  extraFields: [],
  placeholder: 'Search',
}

export default SchoolAsyncSelect